export default {"src":"/_next/static/media/instagram-icon.75d83002.svg","height":24,"width":24};